import { Injectable } from '@angular/core';
import { Business } from '@models/businesses';
import {
	Matter,
	PersonMatterClient,
	BusinessMatterClient,
} from '@models/matter';
import { AllAdjustmentsCalculated } from '@state/matter/adjustments/adjustments.selectors';
import { cloneDeep } from 'lodash';
import { BaseFormMapper } from '../../base-form-mapper';
import { NameFormattingSettings } from '@models/businessSettings/settings';

@Injectable({
	providedIn: 'root',
})
export class BMO_CONVENTIONAL_ACKNOWLEDGEMENT_AND_DIRECTION_Mapper extends BaseFormMapper<BMO_CONVENTIONAL_ACKNOWLEDGEMENT_AND_DIRECTION> {
	CloserToFormMappings = Mappings;

	mergeFormData(
		formData: BMO_CONVENTIONAL_ACKNOWLEDGEMENT_AND_DIRECTION,
		matter: Matter,
		nameFormattingSettings: NameFormattingSettings,
		sellers: (PersonMatterClient | BusinessMatterClient)[],
		buyers: (PersonMatterClient | BusinessMatterClient)[],
		adjustments: AllAdjustmentsCalculated,
		business: Business,
	) {
		const _formData = formData
			? cloneDeep(formData)
			: ({} as BMO_CONVENTIONAL_ACKNOWLEDGEMENT_AND_DIRECTION);

		return _formData;
	}

	MapValues(): Partial<BMO_CONVENTIONAL_ACKNOWLEDGEMENT_AND_DIRECTION> {
		return {};
	}
}

const Mappings: BMO_CONVENTIONAL_ACKNOWLEDGEMENT_AND_DIRECTION = {
	// "0":"ButtonSubmit2",
	// "1":"ButtonSubmit1",
	// "2":"ButtonSubmit0",
	spouseConsentGuarantor2Name: 'Text23',
	spouseConsentGuarantor1Name: 'Text22',
	spouseConsentWitnessName: 'Text21',
	spouseConsentYear: 'Text20',
	spouseConsentDate: 'Text19',
	guarantorsLine2: 'Text18',
	guarantorsLine1: 'Text17',
	agreementDatedAt: 'Text16',
	spouseName: 'Text15',
	spouseWitnessName: 'Text14',
	spouseOf: 'Text13',
	firmName: 'Text7',
	lawyerName: 'Text6',
	year: 'Text9',
	date: 'Text8',
	borrower2Name: 'Text12',
	borrower1Name: 'Text11',
	witnessName: 'Text10',
	borrowersLine2: 'Text5',
	borrowersLine1: 'Text4',
	pin: 'Text3',
	addressLine2: 'Text2',
	addressLine1: 'Text1',
};

export interface BMO_CONVENTIONAL_ACKNOWLEDGEMENT_AND_DIRECTION {
	addressLine1: string;
	addressLine2: string;
	pin: string;
	borrowersLine1: string;
	borrowersLine2: string;

	lawyerName: string;
	firmName: string;

	date: string;
	year: string;

	witnessName: string;
	borrower1Name: string;
	borrower2Name: string;

	spouseOf: string;
	spouseWitnessName: string;
	spouseName: string;

	agreementDatedAt: string;

	guarantorsLine1: string;
	guarantorsLine2: string;

	spouseConsentDate: string;
	spouseConsentYear: string;

	spouseConsentWitnessName: string;
	spouseConsentGuarantor1Name: string;
	spouseConsentGuarantor2Name: string;
}
